export default {
	'total-benefit-for-kg': 'Total benefits for 1kg',
	accept: 'Accept',
	reject: 'Reject',
	'confirm-acceptance': 'Confirm acceptance',
	'losing-purchase-alert': 'This simulation shows that the offer is a losing offer.\nAre you sure you want to accept it?',
}